import Button, { ButtonProps } from "@material-ui/core/Button";
import { wrapLink, LinkProps } from "./Link";



export type ButtonLinkProps =  Omit<ButtonProps, "component"> & LinkProps;
export const ButtonLink = wrapLink<ButtonLinkProps>(Button);
